<template>
  <div>
    <b-card :title="$t('surgery.patient-surgery-consumables')">
      <b-card-text>
        <b-row>
          <!-- <b-col lg="4">
            <CategoryModal @category="assignCategory" />
          </b-col>
          <b-col v-if="sciFilter" lg="4">
            <AutoComplete
              :label="$t('surgery.consumables')"
              :placeholder="`${$t('common.select')} ${$t(
                'surgery.consumable'
              )}`"
              v-model="consumablesForm.item_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[category_id]=${sciFilter}`"
            />
          </b-col> -->

        </b-col>
          <b-col v-if="" lg="4">
            <AutoComplete
            :label="$t('surgery.consumables')"
              :placeholder="$t('surgery.consumables')"
              v-model="itemId"
              :serializer="(val) => val"
              param-query=""
              no-sort
              other-query="include[]=item&include[]=warehouse&distinct_items=1"
              endpoint="surgeryItemsBalance"
              text-title="item.name"
              alt-search="item_id"
              style="flex: 1"
            />
          </b-col>

          <b-col lg="4">
            <b-form-group :label="$t('pharmacy.Quantity')" label-for="Quantity">
              <b-form-input
                type="number"
                id="Quantity"
                v-model="consumablesForm.quantity"
                :placeholder="$t('pharmacy.Quantity')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <!-- <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                type="number"
                id="Price"
                v-model="consumablesForm.price"
                :placeholder="$t('common.price')"
              />
            </b-form-group> -->
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            class="mt-2"
            ref="myButton"
            variant="primary"
            @click="addToConsumablesList"
          >
            {{ $t('common.add') }}
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <b-card :title="$t('surgery.patient-surgery-consumables')">
      <b-table
        :items="consumables"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="consumables.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t('common.submit') }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import vSelect from 'vue-select';
const CategoryModal = () => import('@/components/warehouse/CategoryModal.vue');

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    CategoryModal,
    BCardText,
    vSelect,
  },
  data() {
    return {
      sciFilter: null,
      itemId: null,
      categoryFilter: {
        name: '',
        id: '',
      },

      loading: true,
      consumablesForm: {
        item_id: '',
        patient_card_surgery_id: this.$route.params.id,
        quantity: '',

        price: '',
      },

      tableColumns: [
        { key: 'item_name', label: this.$t('common.name'), sortable: true },

        {
          key: 'quantity',
          label: this.$t('pharmacy.Quantity'),
          sortable: true,
        },

        // { key: 'price', label: this.$t('common.price'), sortable: true },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      consumables: [],
      params: {
        form: {},
        path: '',
      },
    };
  },

  methods: {
    addToConsumablesList() {
      this.consumablesForm.item_id = this.itemId.item_id;
      this.consumablesForm.item_name = this.itemId.item.name;
      console.log(this.consumablesForm);
      this.consumables.push(this.consumablesForm);
      this.itemId = null;
      this.sciFilter = null;
      this.consumablesForm = {
        item_id: '',
        patient_card_surgery_id: this.$route.params.id,
        quantity: '',

        price: '',
      };
    },
    removeItem(item) {
      this.consumables = this.consumables.filter((drug) => drug !== item);
    },

    assignCategory(v) {
      this.consumablesForm.item_id = null;
      this.sciFilter = v.id;
    },

    submitItem() {
      this.consumables = this.consumables.map((drug) => ({
        ...drug,
        item_id: drug.item_id,
        price: 0,
      }));

      (this.params.form = { consumables: this.consumables }),
        (this.params.path = `/patientSurgeryConsumable`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.$router.go(-1);

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Created',
                variant: 'success',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
